/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/img-redundant-alt */
import "react-step-progress/dist/index.css";
import { useState } from "react";
import html2pdf from "html2pdf.js";
import Navigateur2 from "../../Header/Navigateur2";
import { Link } from "react-router-dom";
import "./Formulaire.css";
import Footers from "../Footer/Footers";
import Footer from "../Footer/Footer";
import ScrollToTop from "../ScrollToTop/ScrollToTop";
import { addDoc, collection } from "firebase/firestore";
import { db } from "../../firebase";
import { ModalHeader } from "@windmill/react-ui";
import { ModalBody } from "react-bootstrap";

const Formulaire = () => {

  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [generatingPDF, setGeneratingPDF] = useState(false);

  const validateForm = () => {

    const requiredFields = [
      "nom","postnom","prenom","lieu_naissance","date_naissance","sexe",
      "nationalite","nom_pere","nom_mere","province_origine","district",
      "territoire","adresse","contact1_nom","contact1_tel","contact2_nom",
      "contact2_tel","ecole_secondaire","province_ecole","commune","section",
      "option","centre_examen","annee_diplome","pourcentage","activites_pro",
      "etudes_post","vacation","first_choice","second_choice"
    ];

    const missingFields = requiredFields.filter((f) => !formData[f] || formData[f].trim() === "");
      if (missingFields.length > 0) {
        alert(`Veuillez remplir les champs obligatoires : ${missingFields.join(", ")}`);
        return false;
      }
    return true;
  };

  const handleChange = (e) => {

    const { name, value } = e.target;
    if (name === "second_choice" && value === formData.first_choice) {
      alert("Le deuxième choix doit être différent du premier !");
      return;
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setLoading(true);
    try {
      // 1. Sauvegarde dans Firestore
      await addDoc(collection(db, "inscriptions"), formData);
      
      // 2. Génération du PDF en passant directement les données courantes
      await generatePDF(formData);

      // 3. Réinitialisation après succès de la génération
      setFormData({});
      e.target.reset();
      setSubmitted(true);
    } catch (error) {
      console.error("Erreur :", error);
      alert("Une erreur est survenue !");
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    setFormData({});
    document.getElementById("candidateForm").reset();
  };

 // ============================================
  //  GÉNÉRATION DU PDF - DOCUMENT OFFICIEL (CORRIGÉ)
  // ============================================
  const generatePDF = async (dataToUse = formData) => {
    // Vérification de la présence de données
    const currentData = { ...dataToUse };
    if (!currentData || Object.keys(currentData).length === 0) {
      alert("Aucune donnée disponible pour générer le PDF. Veuillez remplir le formulaire.");
      return;
    }

    setGeneratingPDF(true);
    let printContainer = null;

    try {
      // 1. Création du conteneur temporaire dans le DOM
      printContainer = document.createElement("div");
      printContainer.id = "pdf-document-container";

      // Styles inline stricts pour garantir que html2canvas capte bien l'élément
      Object.assign(printContainer.style, {
        // position: "absolute",
        top: "0",
        left: "0",
        // width: "794px", // Largeur standard A4 à 96 DPI
        backgroundColor: "#ffffff",
        zIndex: "99999", // Placé temporairement au-dessus pour la capture
        opacity: "1",
        visibility: "visible"
      });

      document.body.appendChild(printContainer);

      const now = new Date();
      const dossierNumber = `INS-${now.getFullYear()}-${String(
            Math.floor(Math.random() * 99999)
      ).padStart(5, "0")}`;

      const dateFormatted = now.toLocaleDateString("fr-FR", {
        day: "2-digit",
        month: "long",
        year: "numeric"
      });

      const formatDate = (d) => {
        if (!d) return "—";
        const dateObj = new Date(d);
        return isNaN(dateObj.getTime()) ? d : dateObj.toLocaleDateString("fr-FR");
      };

      const F = (key, fallback = "—") => {
           const val = currentData[key];
           return val && val.toString().trim() ? val.toString().trim() : fallback;
      };

      // 2. Structure HTML avec styles inlinés pour éviter la perte de CSS
      printContainer.innerHTML = `
        <div style="font-family: Arial, sans-serif; color: #1a1a1a; background: #ffffff; padding: 25px 30px; font-size: 10pt; line-height: 1.4;">
          
          <div style="display: flex; justify-content: space-between; align-items: flex-start; padding-bottom: 10px; border-bottom: 3px double #8B0000;">
            <div style="flex: 1;">
              <div style="font-weight: bold; font-size: 12pt; text-transform: uppercase;">RÉPUBLIQUE DÉMOCRATIQUE DU CONGO</div>
              <div style="font-size: 10pt; font-style: italic; margin-top: 2px;">Ministère de l'Enseignement Supérieur et Universitaire</div>
              <div style="font-weight: bold; font-size: 12pt; color: #8B0000; margin-top: 5px; text-transform: uppercase;">Institut Supérieur de Statistique de Lubumbashi</div>
            </div>
            <div style="text-align: right;">
              <div style="width: 50px; height: 50px; border: 2px solid #8B0000; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-weight: bold; color: #8B0000; font-size: 14pt; background: #fef7f7; margin-left: auto;">ISS</div>
              <div style="font-size: 8pt; font-weight: bold; margin-top: 5px; color: #555;">Année académique ${now.getFullYear()}-${now.getFullYear() + 1}</div>
            </div>
          </div>

          <div style="text-align: center; padding: 15px 0 10px;">
            <h1 style="font-size: 18pt; margin: 0; font-weight: bold; color: #8B0000; text-transform: uppercase; border-bottom: 2px solid #8B0000; display: inline-block; padding: 0 15px 3px;">FICHE D'INSCRIPTION</h1>
            <div style="margin-top: 5px; font-size: 10pt; font-style: italic; color: #444;">Demande d'admission — ${F("vacation")}</div>
          </div>

          <div style="display: flex; justify-content: space-between; background: #f5f5f5; border: 1px solid #ccc; padding: 6px 12px; margin-bottom: 12px; font-size: 9pt;">
            <div><span>N° de dossier :</span> <strong>${dossierNumber}</strong></div>
            <div><span>Date :</span> <strong>${dateFormatted}</strong></div>
            <div><span>Vacation :</span> <strong>${F("vacation")}</strong></div>
          </div>

          <div style="margin-bottom: -12px;">
            <h2 style="font-size: 10pt; font-weight: bold; color: #ffffff; background: #8B0000; padding: 4px 8px; margin: 0; text-transform: uppercase;">I. IDENTITÉ DU CANDIDAT</h2>
            <table style="width: 100%; border-collapse: collapse; font-size: 9pt; border: 1px solid #CCC; margin-top: 3px;">
              <tbody>
                <tr><th style="border: 1px solid #CCC; padding: 4px; background: #f0ecec; width: 15%;">Nom</th><td style="border: 1px solid #CCC; padding: 4px;">${F("nom")}</td><th style="border: 1px solid #CCC; padding: 4px; background: #f0ecec; width: 15%;">Post-nom</th><td style="border: 1px solid #CCC; padding: 4px;">${F("postnom")}</td><th style="border: 1px solid #CCC; padding: 4px; background: #f0ecec; width: 15%;">Prénom</th><td style="border: 1px solid #CCC; padding: 4px;">${F("prenom")}</td></tr>
                <tr><th style="border: 1px solid #CCC; padding: 4px; background: #f0ecec;">Lieu Naiss.</th><td colspan="2" style="border: 1px solid #CCC; padding: 4px;">${F("lieu_naissance")}</td><th style="border: 1px solid #CCC; padding: 4px; background: #f0ecec;">Date Naiss.</th><td colspan="2" style="border: 1px solid #CCC; padding: 4px;">${formatDate(currentData.date_naissance)}</td></tr>
                <tr><th style="border: 1px solid #CCC; padding: 4px; background: #f0ecec;">Sexe</th><td style="border: 1px solid #CCC; padding: 4px;">${F("sexe") === "M" ? "Masculin" : F("sexe") === "F" ? "Féminin" : "—"}</td><th style="border: 1px solid #CCC; padding: 4px; background: #f0ecec;">Nationalité</th><td colspan="3" style="border: 1px solid #CCC; padding: 4px;">${F("nationalite")}</td></tr>
                <tr><th style="border: 1px solid #CCC; padding: 4px; background: #f0ecec;">Nom du père</th><td colspan="2" style="border: 1px solid #CCC; padding: 4px;">${F("nom_pere")}</td><th style="border: 1px solid #CCC; padding: 4px; background: #f0ecec;">Nom de la mère</th><td colspan="2" style="border: 1px solid #CCC; padding: 4px;">${F("nom_mere")}</td></tr>
                <tr><th style="border: 1px solid #CCC; padding: 4px; background: #f0ecec;">Province</th><td colspan="2" style="border: 1px solid #CCC; padding: 4px;">${F("province_origine")}</td><th style="border: 1px solid #CCC; padding: 4px; background: #f0ecec;">District</th><td colspan="2" style="border: 1px solid #CCC; padding: 4px;">${F("district")}</td></tr>
                <tr><th style="border: 1px solid #CCC; padding: 4px; background: #f0ecec;">Territoire</th><td colspan="5" style="border: 1px solid #CCC; padding: 4px;">${F("territoire")}</td></tr>
                <tr><th style="border: 1px solid #CCC; padding: 4px; background: #f0ecec;">Adresse</th><td colspan="5" style="border: 1px solid #CCC; padding: 4px;">${F("adresse")}</td></tr>
              </tbody>
            </table>
          </div>

          <div style="margin-bottom: -12px;">
            <h2 style="font-size: 10pt; font-weight: bold; color: #ffffff; background: #8B0000; padding: 4px 8px; margin: 0; text-transform: uppercase;">CONTACTS D'URGENCE</h2>
           
            <table style="width: 100%; border-collapse: collapse; font-size: 9pt; border: 1px solid #CCC; margin-top: 3px;">
              <thead>
                <tr style="background: #f0ecec;">
                  <th style="border: 1px solid #CCC; padding: 4px; width: 10%;text-align: center;">N°</th>
                  <th style="border: 1px solid #CCC; padding: 4px;">Nom complet</th>
                  <th style="border: 1px solid #CCC; padding: 4px;">Téléphone</th>
                </tr>
              </thead>
              <tbody>
                <tr><td style="border: 1px solid #CCC; padding: 4px; text-align: center;">1</td><td style="border: 1px solid #CCC; padding: 4px;">${F("contact1_nom")}</td><td style="border: 1px solid #CCC; padding: 4px;">${F("contact1_tel")}</td></tr>
                <tr><td style="border: 1px solid #CCC; padding: 4px; text-align: center;">2</td><td style="border: 1px solid #CCC; padding: 4px;">${F("contact2_nom")}</td><td style="border: 1px solid #CCC; padding: 4px;">${F("contact2_tel")}</td></tr>
              </tbody>
            </table>
            
          </div>

          <div style="margin-bottom: -12px;">
            <h2 style="font-size: 10pt; font-weight: bold; color: #ffffff; background: #8B0000; padding: 4px 8px; margin: 0; text-transform: uppercase;">II. ÉTUDES SECONDAIRES</h2>
            <table style="width: 100%; border-collapse: collapse; font-size: 9pt; border: 1px solid #CCC; margin-top: 3px;">
              <tbody>
                <tr><th style="border: 1px solid #CCC; padding: 4px; background: #f0ecec;">École</th><td colspan="2" style="border: 1px solid #CCC; padding: 4px;">${F("ecole_secondaire")}</td><th style="border: 1px solid #CCC; padding: 4px; background: #f0ecec;">Province</th><td colspan="2" style="border: 1px solid #CCC; padding: 4px;">${F("province_ecole")}</td></tr>
                <tr><th style="border: 1px solid #CCC; padding: 4px; background: #f0ecec;">Commune</th><td colspan="2" style="border: 1px solid #CCC; padding: 4px;">${F("commune")}</td><th style="border: 1px solid #CCC; padding: 4px; background: #f0ecec;">Section</th><td colspan="2" style="border: 1px solid #CCC; padding: 4px;">${F("section")}</td></tr>
                <tr><th style="border: 1px solid #CCC; padding: 4px; background: #f0ecec;">Option</th><td colspan="2" style="border: 1px solid #CCC; padding: 4px;">${F("option")}</td><th style="border: 1px solid #CCC; padding: 4px; background: #f0ecec;">Centre Examen</th><td colspan="2" style="border: 1px solid #CCC; padding: 4px;">${F("centre_examen")}</td></tr>
                <tr><th style="border: 1px solid #CCC; padding: 4px; background: #f0ecec;">Année</th><td style="border: 1px solid #CCC; padding: 4px;">${F("annee_diplome")}</td><th style="border: 1px solid #CCC; padding: 4px; background: #f0ecec;">Pourcentage</th><td style="border: 1px solid #CCC; padding: 4px;">${F("pourcentage")}</td><th style="border: 1px solid #CCC; padding: 4px; background: #f0ecec;">N° diplôme</th><td style="border: 1px solid #CCC; padding: 4px;">${F("numero_diplome")}</td></tr>
              </tbody>
            </table>
          </div>

          <div style="margin-bottom: -12px;">
            <h2 style="font-size: 10pt; font-weight: bold; color: #ffffff; background: #8B0000; padding: 4px 8px; margin: 0; text-transform: uppercase;">III. FILIÈRES CHOISIES</h2>
            <table style="width: 100%; border-collapse: collapse; font-size: 9pt; border: 1px solid #CCC; margin-top: 3px;">
              <tbody>
                <tr><th style="border: 1px solid #CCC; padding: 4px; background: #f0ecec; width: 25%;">Premier choix</th><td style="border: 1px solid #CCC; padding: 4px; font-weight: bold; color: #8B0000;">${F("first_choice")}</td></tr>
                <tr><th style="border: 1px solid #CCC; padding: 4px; background: #f0ecec;">Deuxième choix</th><td style="border: 1px solid #CCC; padding: 4px; font-weight: bold; color: #8B0000;">${F("second_choice")}</td></tr>
              </tbody>
            </table>
          </div>

          <div style="margin-bottom: -12px;">
            <h2 style="font-size: 10pt; font-weight: bold; color: #ffffff; background: #8B0000; padding: 4px 8px; margin: 0; text-transform: uppercase;">IV. BORDEREAU DE VERSEMENT</h2>
            <table style="width: 100%; border-collapse: collapse; font-size: 9pt; border: 1px solid #CCC; margin-top: 3px;">
              <tbody>
                <tr><th style="border: 1px solid #CCC; padding: 4px; background: #f0ecec;">N° bordereau</th><td style="border: 1px solid #CCC; padding: 4px;">${F("numero_bordereau")}</td><th style="border: 1px solid #CCC; padding: 4px; background: #f0ecec;">Code opération</th><td style="border: 1px solid #CCC; padding: 4px;">${F("operation")}</td><th style="border: 1px solid #CCC; padding: 4px; background: #f0ecec;">Date paiement</th><td style="border: 1px solid #CCC; padding: 4px;">${formatDate(currentData.date_paiement)}</td></tr>
              </tbody>
            </table>
          </div>

          <div style="margin-top: 10px; padding: 8px; background: #fafafa; border: 1px dashed #888; font-style: italic; font-size: 8.5pt;">
             Je soussigné(e), <strong>${F("prenom")} ${F("postnom")} ${F("nom")}</strong>, certifie l'exactitude des renseignements fournis ci-dessus et m'engage à respecter le règlement intérieur de l'établissement.
          </div>

          <div style="display: flex; justify-content: space-between; margin-top: 25px;">
            <div style="flex: 1; text-align: center; border-top: 1px solid #8B0000; padding-top: 4px; margin-right: 20px;">
              <div style="font-weight: bold; font-size: 9pt; text-transform: uppercase; color: #8B0000;">Le Candidat</div>
              <div style="height: 40px;"></div>
              <div style="font-size: 7.5pt; font-style: italic; color: #666;">Signature précédée de « Lu et approuvé »</div>
            </div>
            <div style="flex: 1; text-align: center; border-top: 1px solid #8B0000; padding-top: 4px; margin-left: 20px;">
              <div style="font-weight: bold; font-size: 9pt; text-transform: uppercase; color: #8B0000;">L'Administration</div>
              <div style="height: 40px;"></div>
              <div style="font-size: 7.5pt; font-style: italic; color: #666;">Cachet et signature</div>
            </div>
          </div>

        </div>
      `;

      // 3. Pause indispensable pour que le navigateur effectue le rendu DOM complet
      await new Promise((resolve) => setTimeout(resolve, 600));

      // 4. Paramètres de html2pdf
      const options = {
        margin: [5, 5, 5, 5],
        filename: `Fiche_Inscription_${F("nom")}_${F("prenom")}.pdf`,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          scale: 2,
          useCORS: true,
          logging: false,
          scrollY: 0,
          scrollX: 0,
          windowWidth: 794
        },
        jsPDF: {
          unit: "mm",
          format: "a4",
          orientation: "portrait"
        }
      };

      // 5. Capture et enregistrement
      await html2pdf().set(options).from(printContainer).save();

    } catch (err) {
      console.error("Erreur génération PDF:", err);
      alert("Erreur lors de la génération du PDF : " + err.message);
    } finally {
      // 6. Suppression du conteneur temporaire
      if (printContainer && printContainer.parentNode) {
        printContainer.parentNode.removeChild(printContainer);
      }
      setGeneratingPDF(false);
    }
  };

  return (
    <div>
      <div className="wrapper">
        <Navigateur2 />
        <main className="main-content site-wrapper-reveal" style={{ paddingTop: 130 }}>
          <section className="page-title-area">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="page-title-content content-style3">
                    <div className="bread-crumbs bread-crumbs-style2">
                      <a>
                        <Link to="/">Acceuil</Link>
                        <span className="breadcrumb-sep">/</span>
                      </a>
                      <span className="active text-black">Inscription</span>
                    </div>
                    <div className="section-title">
                      <h4 className="title" data-aos="fade-zoom-in" data-aos-duration="1300">
                        FORMULAIRE DE DEMANDE <span>D'INSCRIPTION</span>
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <form id="candidateForm" onSubmit={handleSubmit}>
            <fieldset>
              <legend>I. Identité du candidat</legend>
              <div className="row">
                <div className="col">
                  <label htmlFor="nom">Nom</label>
                  <input id="nom" name="nom" type="text" onChange={handleChange} />
                </div>
                <div className="col">
                  <label htmlFor="postnom">Post-nom</label>
                  <input id="postnom" name="postnom" type="text" onChange={handleChange} />
                </div>
                <div className="col">
                  <label htmlFor="prenom">Prénom</label>
                  <input id="prenom" name="prenom" type="text" onChange={handleChange} />
                </div>
              </div>

              <div className="row">
                <div className="col">
                  <label htmlFor="lieu_naissance">Lieu de naissance</label>
                  <input id="lieu_naissance" name="lieu_naissance" type="text" onChange={handleChange} />
                </div>
                <div className="col">
                  <label htmlFor="date_naissance">Date de naissance</label>
                  <input id="date_naissance" name="date_naissance" type="date" onChange={handleChange} />
                </div>
                <div className="col">
                  <label>Sexe</label>
                  <div className="inline">
                    <input id="sexe_m" name="sexe" value="M" type="radio" onChange={handleChange} />
                    <label htmlFor="sexe_m">Masculin</label>
                  </div>
                  <div className="inline">
                    <input id="sexe_f" name="sexe" value="F" type="radio" onChange={handleChange} />
                    <label htmlFor="sexe_f">Féminin</label>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col">
                  <label htmlFor="nationalite">Nationalité</label>
                  <input id="nationalite" name="nationalite" type="text" onChange={handleChange} />
                </div>
                <div className="col">
                  <label htmlFor="nom_pere">Nom du père</label>
                  <input id="nom_pere" name="nom_pere" type="text" onChange={handleChange} />
                </div>
                <div className="col">
                  <label htmlFor="nom_mere">Nom de la mère</label>
                  <input id="nom_mere" name="nom_mere" type="text" onChange={handleChange} />
                </div>
              </div>

              <div className="row">
                <div className="col">
                  <label htmlFor="province_origine">Province d'origine des parents</label>
                  <input id="province_origine" name="province_origine" type="text" onChange={handleChange} />
                </div>
                <div className="col">
                  <label htmlFor="district">District</label>
                  <input id="district" name="district" type="text" onChange={handleChange} />
                </div>
                <div className="col">
                  <label htmlFor="territoire">Territoire</label>
                  <input id="territoire" name="territoire" type="text" onChange={handleChange} />
                </div>
              </div>

              <label htmlFor="adresse">Adresse du candidat</label>
              <textarea id="adresse" name="adresse" onChange={handleChange} placeholder="Adresse complète..."></textarea>

              <label>Personnes à contacter en cas d'urgence</label>
              <div className="row">
                <div className="col">
                  <input id="contact1_nom" name="contact1_nom" type="text" placeholder="Nom, Post-nom, Prénom" onChange={handleChange} />
                </div>
                <div className="col">
                  <input id="contact1_tel" name="contact1_tel" type="tel" pattern="[0-9]{9,}" placeholder="N° Téléphone" onChange={handleChange} />
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <input id="contact2_nom" name="contact2_nom" type="text" placeholder="Nom, Post-nom, Prénom" onChange={handleChange} />
                </div>
                <div className="col">
                  <input id="contact2_tel" name="contact2_tel" type="tel" pattern="[0-9]{9,}" placeholder="N° Téléphone" onChange={handleChange} />
                </div>
              </div>
            </fieldset>

            <fieldset>
              <legend>II. Études secondaires faites</legend>
              <div className="row">
                <div className="col">
                  <label htmlFor="ecole_secondaire">Nom de l'école secondaire</label>
                  <input id="ecole_secondaire" name="ecole_secondaire" type="text" onChange={handleChange} />
                </div>
                <div className="col">
                  <label htmlFor="province_ecole">Province</label>
                  <input id="province_ecole" name="province_ecole" type="text" onChange={handleChange} />
                </div>
                <div className="col">
                  <label htmlFor="commune">Commune</label>
                  <input id="commune" name="commune" type="text" onChange={handleChange} />
                </div>
              </div>

              <div className="row">
                <div className="col">
                  <label htmlFor="section">Section</label>
                  <input id="section" name="section" type="text" onChange={handleChange} />
                </div>
                <div className="col">
                  <label htmlFor="option">Option</label>
                  <input id="option" name="option" type="text" onChange={handleChange} />
                </div>
                <div className="col">
                  <label htmlFor="centre_examen">Centre examen d'État</label>
                  <input id="centre_examen" name="centre_examen" type="text" onChange={handleChange} />
                </div>
              </div>

              <div className="row">
                <div className="col">
                  <label htmlFor="annee_diplome">Année d'obtention</label>
                  <input id="annee_diplome" name="annee_diplome" type="number" min="1900" max="2026" onChange={handleChange} />
                </div>
                <div className="col">
                  <label htmlFor="pourcentage">Pourcentage obtenu</label>
                  <input id="pourcentage" name="pourcentage" type="text" onChange={handleChange} />
                </div>
                <div className="col">
                  <label htmlFor="numero_diplome">Numéro du diplôme</label>
                  <input id="numero_diplome" name="numero_diplome" type="text" onChange={handleChange} />
                </div>
              </div>
            </fieldset>

            <fieldset>
              <legend>III. Occupations après les humanités</legend>
              <label htmlFor="activites_pro">Activités professionnelles</label>
              <textarea id="activites_pro" name="activites_pro" onChange={handleChange}></textarea>

              <label htmlFor="etudes_post">Études post-secondaires entreprises</label>
              <textarea id="etudes_post" name="etudes_post" onChange={handleChange}></textarea>
            </fieldset>

            <fieldset>
              <legend>IV. Choix de la vacation</legend>
              <div className="inline">
                <input id="vacation_jour" name="vacation" type="radio" value="Jour" onChange={handleChange} />
                <label htmlFor="vacation_jour">Jour</label>
              </div>
              <div className="inline">
                <input id="vacation_soir" name="vacation" type="radio" value="Soir" onChange={handleChange} />
                <label htmlFor="vacation_soir">Soir</label>
              </div>
            </fieldset>

            <fieldset>
              <legend>V. Filières organisées</legend>
              <label>Premier choix</label>
              <div className="choices">
                {["Statistique appliquée aux assurances","Statistique appliquée à la mobilité","Statistique agricole","Douane et Accise","Banque et assurance","Sciences Commerciales et financières","Gestion des entreprises","Informatique Appliquée à la Gestion des Entreprises","Intelligence Artificielle","Génie Logiciel","Réseaux et Télécommunication"].map((filiere) => (
                  <label key={filiere}>
                    <input className="selects" type="radio" name="first_choice" value={filiere} onChange={handleChange} />
                    {filiere}
                  </label>
                ))}
              </div>

              <label>Deuxième choix</label>
              <div className="choices">
                {["Statistique appliquée aux assurances","Statistique appliquée à la mobilité","Statistique agricole","Douane et Accise","Banque et assurance","Sciences Commerciales et financières","Gestion des entreprises","Informatique Appliquée à la Gestion des Entreprises","Intelligence Artificielle","Génie Logiciel","Réseaux et Télécommunication"].map((filiere) => (
                  <label key={filiere}>
                    <input className="selects" type="radio" name="second_choice" value={filiere} onChange={handleChange} />
                    {filiere}
                  </label>
                ))}
              </div>
            </fieldset>

            <fieldset>
              <legend>VI. Bordereau de versement</legend>
              <div className="row">
                <div className="col">
                  <label htmlFor="numero_bordereau">Numéro bordereau</label>
                  <input id="numero_bordereau" name="numero_bordereau" type="text" onChange={handleChange} />
                </div>
                <div className="col">
                  <label htmlFor="operation">Code opération</label>
                  <input id="operation" name="operation" type="text" onChange={handleChange} />
                </div>
                <div className="col">
                  <label htmlFor="date_paiement">Date de Paiement</label>
                  <input id="date_paiement" name="date_paiement" type="date" onChange={handleChange} />
                </div>
              </div>
            </fieldset>

            <div className="btns">

              
              <button type="submit" disabled={loading}>
                {loading ? "Enregistrement..." : "Soumettre"}
              </button>
              <button type="button" className="secondary" onClick={handleReset}>
                Réinitialiser
              </button>
             
            </div>

            {submitted && (
              <div style={{ textAlign: 'center' }}>
                <ModalHeader>
                  <h1 className="text-lg font-bold text-green-600">🎉 Félicitations !!!</h1>
                </ModalHeader>
                <ModalBody>
                  <div className="space-y-2">
                    <p>Votre demande d'inscription a bien été enregistrée.</p>
                    <p className="text-sm text-gray-500">Merci de votre confiance 🙏</p>
                    <p className="text-sm text-blue-600">Votre fiche d'inscription officielle a été générée.</p>
                  </div>
                </ModalBody>
              </div>
            )}
          </form>

          <Footers />
        </main>

        <Footer />
        <ScrollToTop />
      </div>
    </div>
  );

};

export default Formulaire;